var _path, _path2, _path3, _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerimeterPluginDark = function SvgPerimeterPluginDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M0 0h27v28H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M-16547-2104c0-1.1.9-2 2-2h43923c1.1 0 2 .9 2 2v17638c0 1.1-.9 2-2 2h-43923c-1.1 0-2-.9-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M-16545-2105h43923v-2h-43923zm43924 1v17638h2V-2104zm-1 17639h-43923v2h43923zm-43924-1V-2104h-2v17638zm1 1c-.6 0-1-.4-1-1h-2c0 1.7 1.3 3 3 3zm43924-1c0 .6-.4 1-1 1v2c1.7 0 3-1.3 3-3zm-1-17639c.6 0 1 .45 1 1h2c0-1.66-1.3-3-3-3zm-43923-2c-1.7 0-3 1.34-3 3h2c0-.55.4-1 1-1zM-2125-1423h14805v-2H-2125zm14806 1v8177h2v-8177zm-1 8178H-2125v2h14805zm-14806-1v-8177h-2v8177zm1 1c-.55 0-1-.45-1-1h-2c0 1.66 1.34 3 3 3zm14806-1c0 .55-.4 1-1 1v2c1.7 0 3-1.34 3-3zm-1-8178c.6 0 1 .45 1 1h2c0-1.66-1.3-3-3-3zm-14805-2c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1404,
    height: 1030,
    x: -496.5,
    y: -625.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5",
    rx: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 268,
    x: -54.5,
    y: -22,
    fill: "#313335",
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    x: -46.5,
    y: -14,
    fill: "#fff",
    rx: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.156,
    cy: 19.663,
    r: 2.374
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.498,
    cy: 2.999,
    r: 2.374
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.842,
    cy: 8.319,
    r: 2.374
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.842,
    cy: 19.663,
    r: 2.374
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.156,
    cy: 8.319,
    r: 2.374
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.498,
    cy: 24.999,
    r: 2.374
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.214 16.826v-5.639M3.843 16.826v-5.639M11.14 23.835l-4.883-2.82M20.835 7.022l-4.883-2.819M6.196 7.022l4.883-2.819M15.97 23.764l4.882-2.819"
  }))));
};
export default SvgPerimeterPluginDark;